import Animated, { useAnimatedStyle, useSharedValue, withTiming } from "react-native-reanimated";
import { Image, StyleSheet, TouchableOpacity, View, useWindowDimensions } from "react-native";
import React, { useEffect, useRef, useState,createRef } from "react";

import { fp, hp, spH, spV, wp } from "utils/normalizeV2";
import { useDispatch, useSelector } from "react-redux";

import BottomSheetModal from "../BottomSheetModal";
    import Carousel from "react-native-reanimated-carousel";
import { Colors } from "colors";
import { Images } from "assets";
import VText from "../VText";
import { useGlobalSearchParams } from "expo-router";
import ComingSoonCop from "components/ComingSoonCop";
import Pagination from "src/components/Pagination";
import Svg, { Circle, Path } from "react-native-svg";
import Buttons from "components/Buttons";
import Cropper from 'react-cropper';
import "cropperjs/dist/cropper.css";
const defaultSrc ="https://raw.githubusercontent.com/roadmanfong/react-cropper/master/example/img/child.jpg";


export default React.forwardRef((props, ref) => {

    const { files,handleUpload } = props;
    const { height, width } = useWindowDimensions();
    const _bottomSheetRef = useRef();
    const local = useGlobalSearchParams();
    const [image, setImage] = useState(defaultSrc);
    const [blob, setBlob] = useState(null);
    const [cropData, setCropData] = useState(null);
    const [imageType, setImageType] = useState("image/jpeg");
    const cropperRef = createRef();
    
    React.useImperativeHandle(ref, () => ({ show }), []);

    const show = () => {
        _bottomSheetRef?.current?.show();
    };

    useEffect(() => {
        if(files.length > 0){
        const reader = new FileReader();
        reader.onload = () => {
            setImage(reader.result);
        };
        reader.readAsDataURL(files[0]);
    }
    }, [files]);



    const getCropData = () => {
        if (typeof cropperRef.current?.cropper !== "undefined") {
            const cropper = cropperRef.current.cropper;
            cropper.getCroppedCanvas({ height: 950 }).toBlob((blob) => {
                const reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onloadend = () => {
                    handleUpload(reader.result);
                    _bottomSheetRef?.current?.hide()
                    // setBlob(reader.result);
                };
            }, imageType); // Use the stored image type
            // handleUpload(blob);

            setCropData(cropper.getCroppedCanvas().toDataURL(imageType)); // Use the stored image type
        }
    };






    return (
        <BottomSheetModal
            MAX_HEIGHT_PERC={1}
            START_PERC={1}
            ref={_bottomSheetRef}
            hideLine
            containerStyle={{
                backgroundColor: "transparent",
                zIndex: 100,
            }}
        >
            <TouchableOpacity
                style={{
                    backgroundColor: "transparent",
                    width,
                    height,
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                    zIndex: 100,
                    cursor: "auto",
                }}
                activeOpacity={1}
                onPress={() => _bottomSheetRef?.current?.hide()}
            >
                
                <TouchableOpacity
                    style={{
                        width: wp(400),
                        height: hp(600),
                        height: "auto",
                        backgroundColor: "#fff",

                        // paddingTop: spV(30),
                        // paddingBottom: spV(15),
                        // paddingHorizontal: spH(40),
                        // overflow: "hidden",
                        cursor: "auto",
                    }}
                    activeOpacity={1}
                >
                    <TouchableOpacity
                        onPress={() => _bottomSheetRef?.current?.hide()}
                        activeOpacity={0.8}
                        style={{
                            position: "absolute",
                            right: 20,
                            top: 20,
                            zIndex: 100,
                            // backgroundColor:"red"
                        }}
                    >
                        <Svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <Circle cx="12" cy="12" r="12" fill="#F7F7F7" />
                            <Path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M11.4693 12.0006L7.75684 15.713L8.28717 16.2433L11.9996 12.5309L15.712 16.2433L16.2423 15.713L12.5299 12.0006L16.2423 8.28814L15.712 7.75781L11.9996 11.4702L8.28717 7.75781L7.75684 8.28814L11.4693 12.0006Z"
                                fill="#212427"
                            />
                        </Svg>
                    </TouchableOpacity>
                    
                    <View   style={{flexDirection:"column",alignItems:"center",marginTop:spV(20),marginBottom:spV(20)}}>

                    <Cropper
                        
                        ref={cropperRef}
                        style={{ height: 500, width: wp(300),marginBottom:spV(20) }}
                        initialAspectRatio={1}
                        // aspectRatio={1}
                        background={false}
                        guides={true}
                        src={image}
                    />

                    <Buttons   onPress={getCropData} containerStyle={{width:wp(100),backgroundColor:"white",borderRadius:4,borderWidth:1,borderColor:"#00000029"}}  textStyle={{fontSize:16,color:"#212427",fontWeight:"500"}}  text="Upload"   />


                    </View>

                  


                </TouchableOpacity>
            </TouchableOpacity>
        </BottomSheetModal>
    );
});

const styles = StyleSheet.create({
    container: {
        backgroundColor: Colors.white,
        borderRadius: 8,
        width: wp(309),
    },
    image: {
        width: wp(309),
        height: hp(199),
    },
});
